import Cookies from "js-cookie";

import { ClaimTimesheetModal } from "./_components/claim-timesheet-modal";
import { useMemo, useState } from "react";
import { fetchAllTimesheetsByYearForEmployeeQueryOptions } from "@/config/queries/emp-query-options";
import { useQuery } from "@tanstack/react-query";

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select/select";
import { SalaryTimesheet as SalaryTimesSheetType } from "./_components/timesheet-table/schema";
import { ColumnDef } from "@tanstack/react-table";
import { getColumns } from "./_components/timesheet-table/columns";
import { DataTable } from "./_components/timesheet-table/data-table";

// const getCurrentYear = () => {
//   return new Date().getFullYear();
// };

function generateYears(): number[] {
  const currentYear = new Date().getFullYear();
  const endYear = 2024;
  const years: number[] = [];

  for (let year = currentYear; year >= endYear; year--) {
    years.push(year);
  }

  return years;
}

const SalaryTimesheet = () => {
  const key = Cookies.get("key") as string;
  const [selectedYear, setSelectedYear] = useState<number>(
    new Date().getFullYear()
  );

  const years = useMemo(() => generateYears(), []);

  const { data, isPending, isFetching } = useQuery(
    fetchAllTimesheetsByYearForEmployeeQueryOptions(key, {
      year: selectedYear,
    })
  );

  const sheets = useMemo(() => {
    if (isPending) {
      return [];
    }

    if (data === undefined || data?.sheets === undefined) {
      return [];
    }

    const result = data?.sheets?.map((sal) => {
      return {
        id: sal?._id,
        month: sal?.month,
        year: sal?.year,
        present: sal?.present,
        absent: sal?.absent,
        createdAt: sal?.createdAt,
        paidLeave: sal?.paidLeave,
        unpaidLeave: sal?.unpaidLeave,
        employeeName: sal?.employee?.name,
        salaryGenerated: sal?.salaryGenerated,
      };
    });

    return result?.sort(
      (a, b) =>
        new Date(b?.createdAt as string).getTime() -
        new Date(a?.createdAt as string).getTime()
    );
  }, [data, isPending, isFetching]);

  const columns = useMemo<ColumnDef<SalaryTimesSheetType, unknown>[]>(
    () => getColumns(),
    []
  );

  return (
    <div className="p-5 h-[calc(100%-56px)]">
      <div className="flex items-center justify-between">
        <h3 className="text-2xl font-medium">Salary Timesheets</h3>

        <ClaimTimesheetModal />
      </div>

      <div className="flex items-center justify-end mt-2">
        <div className="flex flex-col md:flex-row gap-3 items-center">
          <div className="flex-1">
            <Select
              value={String(selectedYear)}
              onValueChange={(value) => {
                setSelectedYear(Number(value));
              }}
            >
              <SelectTrigger className="w-full">
                <SelectValue placeholder="Select a year" />
              </SelectTrigger>
              <SelectContent className="max-h-[300px]">
                <SelectGroup>
                  {years.map((year) => {
                    return (
                      <SelectItem key={year} value={String(year)}>
                        {year}
                      </SelectItem>
                    );
                  })}
                </SelectGroup>
              </SelectContent>
            </Select>
          </div>
        </div>
      </div>

      <div className="mt-5 mb-10 pb-10">
        <DataTable data={sheets} columns={columns} />
      </div>
    </div>
  );
};

export default SalaryTimesheet;
